import * as React from "react";
import type { SVGProps } from "react";
const SvgPlusSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#plus-small_svg__a)">
      <path d="M16 13H8a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2" />
      <path d="M12 17a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v8a1 1 0 0 1-1 1" />
    </g>
    <defs>
      <clipPath id="plus-small_svg__a">
        <path fill="#fff" d="M7 7h10v10H7z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPlusSmall;
